<template>
  <div>
    <router-view name="banner" />
    <div class="block-info main-wrapper overflow-hidden">
      <div class="container">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
    </div>
  </div>
</template>

<script>
import storage from "../helpers/storage";

export default {
  props: {
    user: Object,
    billing: Object,
    shipping: Object
  },
  created() {
    const contactData = this.user
      ? {
          fullName: this.user.full_name,
          email: this.user.email,
          contactNumber: this.user.contact,
          isAuthUser: true
        }
      : storage.get("_contact") || {};

    const billingData = this.billing
      ? {
          firstName: this.user.first_name,
          lastName: this.user.last_name,
          contactNumber: this.user.contact,
          unit: this.billing.unit,
          barangay: this.billing.barangay,
          city: this.billing.city,
          province: this.billing.province,
          postalCode: this.billing.postal_code,
          country: this.billing.country
        }
      : storage.get("_billing") || {};

    const shippingData = this.shipping
      ? {
          firstName: this.user.first_name,
          lastName: this.user.last_name,
          contactNumber: this.user.contact,
          unit: this.shipping.unit,
          barangay: this.shipping.barangay,
          city: this.shipping.city,
          province: this.shipping.province,
          postalCode: this.shipping.postal_code,
          country: this.shipping.country
        }
      : storage.get("_shipping") || {};

    this.$store.dispatch("checkout/loadContact", contactData);
    this.$store.dispatch("checkout/loadBilling", billingData);
    this.$store.dispatch("checkout/loadShipping", shippingData);
  },
  mounted(){
    this.$router.replace({name: 'cart'});
  }
};
</script>

<style></style>
